import React, { useState } from 'react';
import { C, DISP, BODY, FadeUp, Kicker, SectionH2, SECTION_PAD, useSectionView, track } from './shared';

const FAQS = [
  {
    q: 'What exactly is a credit?',
    a: 'One credit covers one written asset: a social post, caption, email, ad copy, SEO piece or daily plan. Bigger jobs cost more: a carousel is 3 credits, a landing page 5, a product shoot 5, a 3D visual ad 6, and a video ad 8 to 12. The exact cost is always shown in the app before you create anything.',
  },
  {
    q: 'Do unused credits roll over?',
    a: 'Monthly plan credits reset at the start of each calendar month. Top-up credits you buy separately stay on your account until you use them.',
  },
  {
    q: 'What happens if a creation fails?',
    a: 'The credits are automatically refunded to your balance. You never pay for a failed result.',
  },
  {
    q: 'What happens when I run out of credits?',
    a: 'You can buy a top-up pack (from $9.99 for 20 credits) or upgrade your plan. Everything you have already created stays available, and the rest of the app keeps working.',
  },
  {
    q: 'How does the brand scan work?',
    a: 'You enter your website URL and ScalitOS reads the publicly visible content on that page to build your brand profile: your positioning, tone and offer. It does not access anything private, and you can edit every detail of the profile afterwards.',
  },
  {
    q: 'Can I cancel? What happens when I do?',
    a: 'Yes. From the Billing page you can open the secure Stripe customer portal to cancel your plan, update your payment method or download invoices. Cancelling stops future renewals. You keep full access and your remaining monthly credits until the end of the period you already paid for. Top-up credits you purchased separately stay on your account even after cancelling. You can reactivate any time from the same portal, or email hello@scalitos.com and we will help.',
  },
  {
    q: 'Is ScalitOS finished?',
    a: 'The core system (brand scan, daily plan, strategy engine, content creation, campaign workspace and analytics) is live. ScalitOS is an early-access product being tested with a small group of founders, and newer features are labelled inside the app.',
  },
];

const FaqItem = ({ q, a, idx }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ border: `1px solid ${open ? C.borderLime : C.border}`, borderRadius: 14, background: open ? 'rgba(200,241,53,0.03)' : C.surface, overflow: 'hidden', transition: 'border-color 0.25s, background 0.25s' }}>
      <button
        onClick={() => { if (!open) track('faq_expanded', { question: q }); setOpen(!open); }}
        aria-expanded={open}
        data-testid={`faq-toggle-${idx}`}
        style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, padding: '20px 22px', textAlign: 'left' }}
      >
        <span style={{ fontFamily: DISP, fontWeight: 700, fontSize: 16, color: C.text, lineHeight: 1.4 }}>{q}</span>
        <span aria-hidden="true" style={{ color: C.lime, fontSize: 20, flexShrink: 0, transform: open ? 'rotate(45deg)' : 'none', transition: 'transform 0.25s' }}>+</span>
      </button>
      {open && (
        <p style={{ padding: '0 22px 22px', fontFamily: BODY, fontSize: 15, lineHeight: 1.75, color: C.body }}>{a}</p>
      )}
    </div>
  );
};

export const FAQSection = () => {
  const ref = useSectionView('faq');
  return (
    <section id="faq" ref={ref} style={{ padding: SECTION_PAD, background: 'rgba(255,255,255,0.012)' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <FadeUp><Kicker center>Questions</Kicker></FadeUp>
        <FadeUp delay={80}><SectionH2 center style={{ marginBottom: 48 }}>Straight answers.</SectionH2></FadeUp>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {FAQS.map((f, i) => (
            <FadeUp key={i} delay={i * 50}>
              <FaqItem q={f.q} a={f.a} idx={i} />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
